import nutrient_use from "../../images/homepage/Nutrient_Usage.png";
import "../../css/common.module.css";

export default function NutrientUsage() {
  return (
    <div className="container mt-6">
      <div className="row block-row">
        <div class="coljustify-content-start pt-2">
           <h5 class="text-start ps-6 card-header fw-semibold block-title" >
           Nutrient Usage
          </h5>
          <p className="fs-5"> </p>
	      <span class="float-start"> <img className="img-fluid" src={nutrient_use}
	       style={{
	            paddingLeft: "0px",
	            paddingRight: "0px",
	            height: "400px",
	          }}
	        ></img></span>
	    </div>

      </div>
    </div>
  );
}
